<template>
  <div class="sum-description-component">
    <!-- Usando flexbox para melhor controle no mobile -->
    <div 
      class="columns is-mobile is-vcentered is-justify-content-space-between"
      :class="{
        'pb-0': type === 'recurrent'
      }"
    >
        <!-- Coluna do Nome (ocupa espaço disponível) -->
        <div
          class="column is-narrow-tablet is-narrow-desktop is-narrow-widescreen is-narrow-fullhd is-flex-grow-1 is-flex-shrink-1 is-truncate-text"
          :class="{
            'pb-0': type === 'recurrent'
          }"
        >
          <!-- Tamanhos de texto responsivos -->
          <span class="is-size-6-mobile is-size-5-tablet has-text-weight-bold has-text-grey-dark is-no-wrap">
            {{ name }}
          </span>
        </div>
        <!-- Coluna do Preço (tamanho automático) -->
        <div
            class="column is-narrow"
            :class="{
              'pb-0': type === 'recurrent'
            }"
        >
          <span class="is-pulled-right" v-if="!hidePrice">
            <!-- Tamanhos de texto responsivos -->
            <span
                class="is-size-7-mobile is-size-6-tablet has-text-weight-light"
                :class="{
                  'has-text-black': type === 'total',
                  'has-text-grey-secondary': !(type === 'total')
                }"
            >R$ </span>
            <span
                class="has-text-weight-light"
                :class="{
                  'has-text-black is-size-5-mobile is-size-4-tablet': type === 'total', // Ajustado para mobile
                  'has-text-grey-secondary is-size-7-mobile is-size-6-tablet': !(type === 'total') // Ajustado para mobile
                }"
            >
              <span v-if="type !== 'recurrent'">{{ price }}</span>
              <span v-else>{{ formatPrice(price * seasonality) }}</span>
            </span>
            <span v-if="type === 'recurrent'" class="is-size-7-mobile is-size-6-tablet has-text-weight-light has-text-grey-secondary">
              {{ unitOfMeasurement }}
            </span>
          </span>
        </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'sum-description',

  props: {
    name: {
      required: true,
      type: String
    },
    price: {
      required: true,
      type: [ String, Number ]
    },
    type: {
      required: true,
      type: String
    },
    seasonality: {
      required: true,
      type: Number
    },
    hidePrice: {
      required: true,
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      unit_of_measurements: {
        1: '/mês',
        6: '/semes..',
        12: '/ano',
      }
    }
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
  },

  computed: {
    unitOfMeasurement() {
      return this.unit_of_measurements[this.seasonality]
    }
  }

}

</script>